import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "../app/modules/Auth/_redux/authRedux";
import { customersSlice } from "../app/modules/ECommerce/_redux/customers/customersSlice";
import { productsSlice } from "../app/modules/ECommerce/_redux/products/productsSlice";
import { remarksSlice } from "../app/modules/ECommerce/_redux/remarks/remarksSlice";
import { specificationsSlice } from "../app/modules/ECommerce/_redux/specifications/specificationsSlice";

import { productSlice } from "../app/redux/product/productSlice";
import { authSlice } from "../app/redux/auth/authSlice";
import { Slice as facilityPlanSlice } from "../app/redux/facilityPlan/facilityPlanSlice";
import { Slice as stepSlice } from "../app/redux/activeStep/activeStepSlice";
import { Slice as stateCartableSlice } from "../app/redux/activeState/activeStateSlice";
import { Slice as cartableSlice } from "../app/redux/activeCartable/activeCartableSlice";
import { Slice as dashboardLoaderSlice } from "../app/redux/dashboardLoader/dashboardLoaderSlice";
import { Slice as favouriteDashboardSearchSlice } from "../app/redux/favouriteDashboardSearch/favouriteDashboardSearchSlice";
import commentSlice from "../app/redux/comments/commentSlice";
import permissonSlice from "../app/redux/permissions/permissonSlice";
import ScrollByIdSlice from "../app/redux/scroolToTreeId/scrollByIdSlice";
import TableSlice from "../app/redux/table/tableSlice";
import ShellConfigSlice from "../app/redux/styleConfig/styleSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  customers: customersSlice.reducer,
  products: productsSlice.reducer,
  remarks: remarksSlice.reducer,
  specifications: specificationsSlice.reducer,

  product: productSlice.reducer,
  auth2: authSlice.reducer,
  facilityPlan: facilityPlanSlice.reducer,
  step: stepSlice.reducer,
  stateCartable: stateCartableSlice.reducer,
  cartable: cartableSlice.reducer,

  dashboardLoader: dashboardLoaderSlice.reducer,
  favouriteDashboardSearch: favouriteDashboardSearchSlice.reducer,
  comment: commentSlice,
  roles: permissonSlice.roles,
  password: permissonSlice.password,
  scroll: ScrollByIdSlice,
  table: TableSlice,
  style: ShellConfigSlice,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
